<template>
  <form-base :teleport-target="dialogTeleportTarget" hide-required-legend>
    <template #form>
      <v-form ref="form">
        <v-autocomplete
          v-if="!localFormField.field"
          :label="$t('customForms.labels.selectABaseField')"
          v-model="localFormField.fieldId"
          prepend-icon="mdi-text"
          required
          :items="fields"
          :item-title="f => `${f.label} - ${f.description}`"
          item-value="id">
          <template v-slot:selection="{ item }">
            {{ item.label }}
          </template>
        </v-autocomplete>

        <div
          class="d-flex flex-column justify-space-between gap-2 border border-radius pa-4"
          v-if="localFormField.field"
          elevation="1">
          <p class="typography-body-md-bold">
            <v-icon class="mr-1" size="x-small">
              mdi-{{ novaCore.customFieldIcons[localFormField.field.type] }}
            </v-icon>
            {{ localFormField.field.label }}
          </p>
          <span>
            <v-chip pill density="compact" color="grey lighten--3">
              {{ novaCore.customFieldLabels[localFormField.field.type] }}
            </v-chip>
          </span>

          <template v-if="localFormField.field.description">
            <v-spacer class="my-2" />
            <p>{{ localFormField.field.description }}</p>
          </template>

          <div
            class="border pa-4 mt-4"
            v-if="localFormField.field.extraFields?.dropDownValues?.length > 0">
            <p class="mb-3">Choices:</p>
            <p class="typography-body-sm text-justify field-choices">
              {{ localFormField.field.extraFields.dropDownValues.slice(0, 10).join('  •  ') }}
            </p>
          </div>
        </div>

        <div class="d-flex flex-column gap-4 mt-8 px-4">
          <div>
            <span>
              <strong class="mr-2">
                {{ $t('customForms.labels.replaceTheLabelOnThisForm') }}:
              </strong>
              <help-icon-tooltip icon-style-class="grey">
                {{
                  $t('customForms.tooltips.thisWillNotReplaceTheLabelOnFormsThatAlsoUseThisField')
                }}
              </help-icon-tooltip>
            </span>
            <v-text-field
              :placeholder="$t('customForms.placeholders.enterALabel')"
              data-testid="custom-forms-field-edit-label-input"
              v-model="localFormField.overrideLabel"></v-text-field>
          </div>
          <div>
            <strong class="mr-2">{{ $t('customForms.labels.requiredForThisForm') }}:</strong>

            <v-switch
              inset
              inline
              data-testid="required-switch"
              hide-details
              density="compact"
              color="primary"
              v-model="localFormField.required"></v-switch>
          </div>
        </div>
      </v-form>
    </template>
    <template #form-actions>
      <action-group
        @cancel="$emit('close')"
        confirm-icon="upload"
        :confirm-label="$t('global.buttons.save')"
        :cancel-label="$t('global.buttons.nevermind')"
        :cancel-icon="null"
        @confirm="submit"></action-group>
    </template>
  </form-base>
</template>

<script>
import { inject } from 'vue';
export default {
  props: {
    formField: {
      type: Object,
      required: false,
      id: String,
      field: Object,
      form: Object
    },
    formId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      localFormField: {},
      fields: []
    };
  },
  methods: {
    async getAllFields() {
      const params = {};
      const fieldId = this.formField?.field?.id;

      if (fieldId) {
        params.s = { id: fieldId };
      }

      const response = await axios.get('/custom-forms/field', { params });
      this.fields = response?.data?.data || [];
    },
    async submit() {
      if (await this.$isFormValid(this.$refs.form)) {
        this.$emit('save', this.localFormField);
      }
    }
  },
  watch: {
    'localFormField.fieldId': {
      handler(fieldId) {
        if (fieldId) {
          this.localFormField.field = this.fields.find(f => f.id === fieldId);
        }
      }
    }
  },
  setup() {
    const dialogTeleportTarget = inject('dialogActionsRef');
    return { dialogTeleportTarget };
  },
  async mounted() {
    await this.getAllFields();
    if (this.formField?.id) {
      this.localFormField = { ...this.formField };
    } else {
      this.localFormField = {
        fieldId: null,
        formId: this.formId
      };
    }
  }
};
</script>
<style scoped lang="scss">
.field-choices {
  max-height: 60px;
  overflow-y: auto;
}
</style>
